import styled from "styled-components";

import { Select } from "@braze/beacon-lab-select";

export const CountryCodeSelectContainer = styled(Select)<{ isDisabled?: boolean }>`
  margin-right: 10px;
  flex: 0 0 130px;
  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;
